export const kSkillServe = 1;
export const kSkillPass = 2;
export const kSkillSet = 3;
export const kSkillSpike = 4;
export const kSkillBlock = 5;
export const kSkillDefense = 6;
export const kSkillFreeball = 7;
export const kSkillCover = 7;
export const kSkillCoachTag = 8;
export const kSkillEndOfSet = 9;
export const kSkillTransitionSO = 10;
export const kSkillTransitionPovar = 11;
export const kSkillPointWonServe = 12;
export const kSkillPointLostServe = 13;
export const kSkillPointWonReceive = 14;
export const kSkillPointLostReceive = 15;
export const kSkilliCodaAttack = 16;
export const kSkilliCodaDefense = 17;
export const kSkillCodeError = 18;
export const kSkillOppositionError = 19;
export const kSkillSettersCall = 20;
export const kSkillSpeedServe = 30;
export const kSkillLift = 40;

export const kOppositionScore = 100;
export const kOppositionError = 101;
export const kOppositionHitKill = 102;
export const kOppositionHitError = 103;
export const kOppositionServeError = 104;
export const kOppositionServeAce = 105;
export const kSkillCommentary = 200;
export const kSkillTimeout = 201;
export const kSkillTechTimeout = 202;
export const kSubstitution = 250;
export const kSkillOppositionServe = 401;
export const kSkillOppositionSpike = 404;

export const kServeH = 1;
export const kServeM = 2;
export const kServeQ = 3;
export const kServeO = 4;

export const kPassH = 1;
export const kPassM = 2;
export const kPassQ = 3;
export const kPassO = 4;

export const kSpikeH = 1;
export const kSpikeM = 2;
export const kSpikeQ = 3;
export const kSpikeT = 4;
export const kSpikeU = 5;
export const kSpikeF = 6;
export const kSpikeO = 7;

export const kFBKills = 0;
export const kFBOppServeErrors = 1;
export const kFBOppErrors = 2;
export const kKills = 3;
export const kOppErrors = 4;
export const kUnsuccessful = 5;
export const kSOUnknown = 6;

export const kStageServe = 1;
export const kStagePass = 2;
export const kStageSet = 3;
export const kStageAttack = 4;
export const kStageBlock = 5;
export const kStageDefense = 6;
export const kStageFreeball = 7;
export const kStageCover = 8;

export const kEventModifierLastTouchError = 1;
export const kEventModifierLastSpikeError = 2;
export const kEventModifierLastSpikeKill = 3;

// ---- Rotation naming convention ----
// `SideOutPercent[1..6]` is stored in the rotation sequence ordered by the
// setter's court position: [pos 1, pos 6, pos 5, pos 4, pos 3, pos 2].
export const kRotationSetterPositions = [1, 6, 5, 4, 3, 2];

// localStorage key for the user's preferred rotation naming convention.
export const kRotationNamingStorage = "VBLiveRotationNaming";

// "R": R1..R6 follow the rotation sequence (R1 = setter in 1, R2 = setter in 6,
//      R3 = setter in 5, R4 = setter in 4, R5 = setter in 3, R6 = setter in 2).
// "S": S1..S6 name the rotation by the setter's court position (S1 = setter in
//      1, S2 = setter in 2, ... S6 = setter in 6).
export const getRotationNaming = () =>
  localStorage.getItem(kRotationNamingStorage) === "R" ? "R" : "S";

// Returns the six rotation labels in the order of `SideOutPercent[1..6]`.
export const getRotationLabels = (naming) => {
  const convention = naming || getRotationNaming();
  if (convention === "R") {
    return ["R1", "R2", "R3", "R4", "R5", "R6"];
  }
  return kRotationSetterPositions.map((pos) => `S${pos}`);
};

// localStorage key for the live-session auto-refresh interval (seconds).
export const kLiveRefreshIntervalStorage = "VBLiveRefreshInterval";
export const kDefaultLiveRefreshInterval = 15;

/** Returns the user-configured refresh interval (seconds), falling back to 15. */
export const getLiveRefreshInterval = () => {
  const v = parseInt(localStorage.getItem(kLiveRefreshIntervalStorage));
  return isNaN(v) || v < 5 ? kDefaultLiveRefreshInterval : v;
};

// localStorage key for the user's preferred Catapult jump-height display unit.
export const kJumpHeightUnitStorage = "VBLiveJumpHeightUnit";
export const kCmPerInch = 2.54;

// "cm": display/filter jump heights in centimetres (Focus CSV's native
//      "Height (m)" field just scaled up). "in": convert to inches.
export const getJumpHeightUnit = () =>
  localStorage.getItem(kJumpHeightUnitStorage) === "in" ? "in" : "cm";

/** Jump height in centimetres, converted to the given/preferred display unit. */
export const jumpHeightInUnit = (heightCm, unit) =>
  (unit || getJumpHeightUnit()) === "in" ? heightCm / kCmPerInch : heightCm;

/** Formats a jump height (metres, as stored on ev.imaHeightM) for display. */
export const formatJumpHeightM = (heightM, unit) => {
  if (heightM == null) return "";
  const u = unit || getJumpHeightUnit();
  const value = jumpHeightInUnit(heightM * 100, u);
  return u === "in" ? `${value.toFixed(1)} in` : `${Math.round(value)} cm`;
};

// Jump Height advanced-filter buckets, boundaries fixed in cm regardless of
// display unit (20/40/60cm ≈ 8/16/24in, the inches labels the user specified).
export const kJumpHeightBucketsCm = ["< 20cm", "20cm - 40cm", "40cm - 60cm", "> 60cm"];
export const kJumpHeightBucketsIn = ["< 8 inches", "8 - 16 inches", "16 - 24 inches", "> 24 inches"];
export const getJumpHeightBucketLabels = (unit) =>
  (unit || getJumpHeightUnit()) === "in" ? kJumpHeightBucketsIn : kJumpHeightBucketsCm;

/** Which of the 4 bucket labels (cm-unit index) a jump height (metres) falls into. */
export const jumpHeightBucketIndex = (heightM) => {
  if (heightM == null) return null;
  const cm = heightM * 100;
  if (cm < 20) return 0;
  if (cm < 40) return 1;
  if (cm < 60) return 2;
  return 3;
};

// POWER PLAY: a team may "call" a Power Play on a serve — winning a rally
// during its 3-rally window earns double points. Extended code carried on
// the serve event: "HP"=Home called, "AP"=Away called, "HAP"/"AHP"=both
// teams called (letter order = who called first). Max 3 per team per match,
// 1 per team per set, can't be called once a team has scored 11 in the set.
export const kPowerPlayCodes = ["HP", "AP", "HAP", "AHP"];

/** Which team(s) ("A"/"B") have an active Power Play for a given code. */
export const powerPlayTeamsForCode = (code) => {
  switch (code) {
    case "HP":
      return ["A"];
    case "AP":
      return ["B"];
    case "HAP":
    case "AHP":
      return ["A", "B"];
    default:
      return [];
  }
};

/** Which team ("A"/"B") called first, for the simultaneous HAP/AHP codes. */
export const powerPlayFirstCallerForCode = (code) => {
  if (code === "HAP") return "A";
  if (code === "AHP") return "B";
  return null;
};
